import { authFetch, headers } from '../_helpers';

export const locationResultsService = {
  casualResults,
  deleteResult,
};

async function casualResults(locationId) {
  const res = await authFetch(
    `/api/Leaderboard/CasualResults/${locationId}`,
    headers.get(),
  );

  return res;
}

async function deleteResult(leaderboardId) {
  const res = await authFetch(
    `/api/Leaderboard/Delete/${leaderboardId}`,
    headers._delete(),
  );

  return res;
}
